// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WeAreInNumbers_wrapper__W1Xvb","itemText":"WeAreInNumbers_itemText__udTNB","itemNumber":"WeAreInNumbers_itemNumber__QhtPi"};